import { render, staticRenderFns } from "./CardProgressbar.vue?vue&type=template&id=564f8a61&scoped=true&"
import script from "./CardProgressbar.vue?vue&type=script&lang=js&"
export * from "./CardProgressbar.vue?vue&type=script&lang=js&"
import style0 from "./CardProgressbar.vue?vue&type=style&index=0&id=564f8a61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f8a61",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VImg,VProgressLinear})
